import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Customers page
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - statuses: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { statuses = [] } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama Pelanggan */}
            <Input
                label="Nama Pelanggan"
                placeholder="Cari nama pelanggan..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        name: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Alamat */}
            <Input
                label="Alamat"
                placeholder="Cari alamat..."
                value={pending.alamat || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        alamat: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Nomor Kontak */}
            <Input
                type="tel"
                label="Nomor Kontak"
                placeholder="Cari nomor kontak..."
                value={pending.kontak || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        kontak: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Status - multiple selection */}
            <Select
                label="Status"
                placeholder="Pilih status"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.status_id)
                            ? pending.status_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        status_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {statuses.map((s) => (
                    <SelectItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
